export const slides = [
  {
    src: '../images/gallery/bathroom1.jpg',
    title: 'Slide Title One',
    description: 'Slide Description One\n\nthis is new line',
  },
  {
    src: '../images/gallery/bedroom1.jpg',
    title: 'Slide Title Two',
    description: 'Slide Description Two',
  },
  {
    src: '../images/gallery/bedroom2.jpg',
    title: 'Slide Title Three',
    description: 'Slide Description Three',
  },
  {
    src: '../images/gallery/conservatory1.jpg',
    title: 'Slide Title Four',
    description: 'Slide Description Four',
  },
  {
    src: '../images/gallery/diningroom1.jpg',
    title: 'Slide Title Five',
    description: 'Slide Description Five',
  },
  {
    src: '../images/gallery/kitchen_sink1.jpg',
    title: 'Slide Title Six',
    description: 'Slide Description Six',
  },
  {
    src: '../images/gallery/kitchen1.jpg',
    title: 'Slide Title Seven',
    description: 'Slide Description Seven',
  },
  {
    src: '../images/gallery/kitchen2.jpg',
    title: 'Slide Title Eight',
    description: 'Slide Description Eight',
  },
  {
    src: '../images/gallery/livingroom1.jpg',
    title: 'Slide Title Nine',
    description: 'Slide Description Nine',
  },
]